import { createSelector } from '@reduxjs/toolkit';
import { createStructuredSelector } from 'reselect';

import { PRICE_SELECTED } from 'shared/data/quoteSteps';
import { extractAssembly } from 'shared/product_tabs/tab_assembly/slice/extractors';

export const selectCurrentVariant = (state) => state.assembly?.currentVariant;
export const selectAssemblyVariants = (state) => state.assembly?.assemblyVariants;
export const selectLoading = (state) => state.assembly?.loading;
export const selectParameters = (state) => state.assembly?.parameters;
export const selectQuote = (state) => state.assembly?.quote;
export const selectQuoteStep = (state) => state.assembly?.quoteStep;
export const selectParametersChanged = (state) => state.assembly?.parametersChanged;
export const selectSuppliers = (state) => state.assembly?.suppliers;
export const selectDestroy = (state) => state.assembly?.destroy;
export const selectLineItemId = (state) => state.assembly?.lineItemId;
export const selectAssemblyValidatorFlag = (state) => state.assembly?.validatorFlag;
export const selectZipFileInputId = (state) => state.assembly?.zip_file_input_id;
export const selectRowSelected = (state) => state.assembly?.parameters?.row_selected;
export const selectFabricationQuote = (state) => state.assembly?.fabrication_quote;

export const selectAssemblyQuantities = (state) => state.assembly?.parameters?.quantities;

export const selectAssemblyDataForParameters = createStructuredSelector({
  quoteStep: selectQuoteStep,
  loading: selectLoading,
  parameters: selectParameters,
  validatorFlag: selectAssemblyValidatorFlag,
});

export const selectAssemblyDataForPrices = createStructuredSelector({
  parameters: selectParameters,
  quote: selectQuote,
  quoteStep: selectQuoteStep,
  parametersChanged: selectParametersChanged,
  suppliers: selectSuppliers,
  assemblyVariants: selectAssemblyVariants,
});

export const selectAssemblyDataForQuote = createStructuredSelector({
  parameters: selectParameters,
  suppliers: selectSuppliers,
  variant: selectCurrentVariant,
});

export const selectAssemblyDataForValidate = createStructuredSelector({
  parametersChanged: selectParametersChanged,
  quoteStep: selectQuoteStep,
});

export const selectAssemblyDataForActions = createStructuredSelector({
  parameters: selectParameters,
  parametersChanged: selectParametersChanged,
  quote: selectQuote,
  quoteStep: selectQuoteStep,
});

export const selectAssemblyDataForCart = createSelector(
  [
    selectParameters,
    selectQuoteStep,
    selectQuote,
    selectDestroy,
    selectLineItemId,
    selectCurrentVariant,
    selectZipFileInputId,
    selectFabricationQuote,
  ],
  (
    parameters,
    quoteStep,
    quote,
    destroy,
    lineItemId,
    currentVariant,
    zip_file_input_id,
    fabrication_quote,
  ) => {
    const items_to_destroy = destroy && lineItemId ? [lineItemId] : [];
    const data_for_forms = {
      quoteStep,
      assemblyVariant: currentVariant,
      parameters,
      zip_file_input_id,
      fabrication_quote,
    };

    return {
      assemblyProps: extractAssembly({ quoteStep, parameters, quote }),
      assemblyToDestroy: items_to_destroy,
      assemblyDataForForms: data_for_forms,
    };
  },
);

export const selectAssemblySelectedQuantity = createSelector(
  [
    selectAssemblyQuantities,
    selectRowSelected,
    selectQuoteStep,
  ],
  (
    quantities,
    row_selected,
    quoteStep,
  ) => {
    const default_quantity = quantities && quantities.length > 0 ? quantities[0] : null;
    if (!quoteStep || quoteStep !== PRICE_SELECTED) return default_quantity;

    return row_selected && default_quantity ? quantities[row_selected] : default_quantity;
  },
);
